import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  HostBinding,
  Input,
  OnInit,
  Output,
} from '@angular/core';

import {
  Account,
  Attachment,
} from '@nymos/accounts/core';

import {
FileUploadRef
} from '@michel.freiha/ng-sdk';

import {
  ImageService,
} from '../../../services/image.service';

@Component({
  selector: 'nym-user-documents-info',
  templateUrl: './user-documents-info.component.html',
  styleUrls: ['./user-documents-info.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserDocumentsInfoComponent implements OnInit {

  @HostBinding('class.nym-user-documents-info')
  protected get classes(): boolean { return true; }

  @Output()
  protected viewAttachments: EventEmitter<any> = new EventEmitter();

  @Input()
  public account: Account;
  private showVisa:boolean;
  private showRs:boolean;
  protected imageBack: FileUploadRef;
  protected imageBackUrl: string;

  protected imageFront: FileUploadRef;
  protected imageFrontUrl: string;

  protected get type(): string {
    return this.account && this.account.document && this.account.document.type;
  }

  protected get additionalType(): string {
    return this.account && this.account.additionalDocument && this.account.additionalDocument.type;
  }

  protected get info(): any {
    return this.account && this.account.document && this.account.document.info;
  }

  protected get additionalInfo(): any {
    return this.account && this.account.additionalDocument && this.account.additionalDocument.info;
  }

  protected get attachments(): Attachment[] {
    return this.account && this.account.document && this.account.document.attachments || [];
  }

  protected get additionalAttachments(): Attachment[] {
    return this.account && this.account.additionalDocument && this.account.additionalDocument.attachments || [];
  }

  protected get urls(): string[] {
    return this.attachments.map((a) => a.url) || [];
  }

  protected get additionalUrls(): string[] {
    return this.additionalAttachments.map((a) => a.url) || [];
  }

  constructor(private _imageService: ImageService) { }

  public ngOnInit(): void {}

  protected viewAttachments$$(index: number): void {
    const attachments = this.attachments;
    this.viewAttachments.emit({ attachments, index });
  }

  protected viewAdditionalAttachments$$(index: number): void {
    const attachments = this.additionalAttachments;
    this.viewAttachments.emit({ attachments, index });
  }

}